import CloseIcon from '@mui/icons-material/Close';
import SvgIcon from '@mui/material/SvgIcon';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { WidgetEvents, postToParent } from '../../utils';

const TICLogo = (props) => {
  return (
    <SvgIcon inheritViewBox {...props}>
      <svg viewBox="0 0 25 40">
        <path
          d="M.034 16.763h10.63v22.364H.034zm14.495 0h10.63v22.364H14.53zM.03 12.666h10.63V.726S6.507.552 3.05 4.376c-3.59 3.97-3.016 8.29-3.016 8.29zm25.09 0H14.497V.726s4.156-.175 7.613 3.65c3.59 3.97 3.015 8.29 3.015 8.29z"
          fillRule="evenodd"
        />
      </svg>
    </SvgIcon>
  );
};

const StyledButton = styled('button')`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.palette.primary.main};
  pointer-events: auto;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 10px;
  overflow: hidden;
  color: white;
  border: none;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  &.opened {
    background-color: ${({ theme }) => theme.palette.background.default};
    color: ${({ theme }) => theme.palette.primary.main};
    &:hover {
      background-color: ${({ theme }) => theme.palette.background.paper};
    }
  }
  &:hover {
    background-color: ${({ theme }) => theme.palette.primary.light};
  }
  svg {
    font-size: 32px;
    position: absolute;
  }
`;

const StyledCloseIcon = styled(CloseIcon)`
  opacity: 0;
  transform: rotate(-60deg);
  transition: all 0.3s ease-in-out;
  &.show {
    opacity: 1;
    transform: rotate(0deg);
  }
`;

const StyledTICLogo = styled(TICLogo)`
  opacity: 1;
  transform: scale(1);
  transition: all 0.3s ease-in-out;
  &.hide {
    opacity: 0;
    transform: scale(0.5);
  }
`;

const LauncherButton = ({ opened, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      postToParent(WidgetEvents.LauncherButtonClick, {});
    }
  };
  return (
    <StyledButton className={opened && 'opened'} onClick={handleClick}>
      <StyledTICLogo className={opened && 'hide'} />
      <StyledCloseIcon className={opened && 'show'} />
    </StyledButton>
  );
};

LauncherButton.propTypes = {
  color: PropTypes.object,
  opened: PropTypes.bool,
  onClick: PropTypes.func,
};

LauncherButton.displayName = 'LauncherButton';

export default LauncherButton;
